import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuthorization from '../common/hooks/useAuthorization';

export const RequireAuthorization = ({ feature = 'my_tasks' }) => {
  const { checkRoleByFeature } = useAuthorization();
  const location = useLocation();

  return checkRoleByFeature(feature) ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default RequireAuthorization;
